import React from 'react';

import { Buttons } from '../../components/buttons';

import PaperLeft from '../../img/hero-paper-left.webp';
import PaperRight from '../../img/hero-paper-right.webp';
import PaperCenter from '../../img/hero-paper-center.webp';
import Ball from '../../img/ball.webp';
import Football from '../../img/card-football.webp';
import Basketball from '../../img/card-basketball.webp';
import Line from '../../img/line.svg';
import Tape from '../../img/hero-tape.webp';
import Dots from '../../img/hero-dots.webp';
import RubleIcon from '../../img/ruble-icon.svg';
import QR from '../../img/qr.webp';
import Logo from '../../img/logo.svg';

import * as styles from './index.module.scss';

export const Hero = () => (
  <section className={styles.hero}>
    <div className={styles.line}>
      <img src={Line} alt="Line" />
    </div>
    <div className={styles.left}>
      <img src={PaperLeft} alt="Paper Left" />
    </div>
    <div className={styles.right}>
      <img src={PaperRight} alt="Paper Right" />
      <div className={styles.ball}>
        <img src={Ball} alt="Ball" />
      </div>
      <div className={styles.dots}>
        <img src={Dots} alt="Dots" />
      </div>
    </div>
    <div className={styles.football}>
      <img src={Football} alt="Football" />
    </div>
    <div className={styles.basketball}>
      <img src={Basketball} alt="Basketball" />
    </div>
    <div className={styles.center}>
      <img src={PaperCenter} alt="Paper Center" />
    </div>
    <header className={styles.header}>
      <div className="container">
        <div className={styles.wrap}>
          <img src={Logo} className={styles.logo} alt="ZENIT" />
          <div className={styles.qr}>
            <img src={QR} alt="QR" />
            <span>Наведи камеру, чтобы скачать</span>
          </div>
        </div>
      </div>
    </header>
    <div className={styles.content}>
      <div className={styles.mainContent}>
        <div className={styles.mainText}>
          <p className={styles.freebet}>Фрибет</p>
          <img className={styles.tape} src={Tape} alt="Tape" />
        </div>
        <p className={styles.amount}>
          3 000 <img className={styles.ruble} src={RubleIcon} alt="₽" />
        </p>
      </div>
      <p className={styles.description}>новым игрокам</p>
      <p className={styles.additional}>Бесплатная ставка. Только пополни счёт</p>
      <Buttons className={styles.stores} />
    </div>
  </section>
);
